import React from 'react'
import { Grid as GridBase, styled } from '@mui/material'
import { Dialog as DialogBase } from '@chilecompra/react-kit/components'

export const Dialog = styled(DialogBase)`
  & > div {
    box-sizing: border-box;
    max-width: 1064px;
    padding: 52px 108px 28px;
  }
`

export const GridContainer = styled(({ height, margin, maxWidth, padding, ...props }) => (
  <GridBase container {...props} />
))`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(({ height, margin, padding, ...props }) => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const Link = styled('a')`
  color: ${props => props.theme.palette.brand.primary};

  &:hover {
    color: ${props => props.theme.palette.blue[35]};
  }

  &:visited {
    color: ${props => props.theme.palette.brand.primary};
  }
`
export const Strong = styled('strong')``
